import styled from "styled-components";

export const FooterStyles = styled.footer`
  background-color: ${({ theme }) => theme.colors?.japaaBlack};
  padding: 6rem 2rem 12rem;
  z-index: 2000;
  position: relative;
  @media (max-width: 480px) {
    //mobile
    padding: 24px 20px;
  }
`;

export const FooterContainer = styled.div`
  margin: 0 auto;
  max-width: 124rem;
  padding: 0 6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  

  @media (max-width: 998px) {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    align-items: initial;
    row-gap: 3rem;
  }

  @media (max-width: 668px) {
    grid-template-columns: 2fr 1fr;
  }
  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 50px;
    max-width: 376px;
    padding: 0;
    margin-bottom: 33px;
  }
`;
export const FooterLogoContainer = styled.div`
  width: 20rem;
  height: 9.934rem;
  cursor: pointer;

  .footer-logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media (max-width: 480px) {
    //mobile

    margin: auto;
    justify-content: center;
    align-items: center;
  }
`;

export const FooterUl = styled.ul`
 color: #FFFFFF;
 list-style: none;

 .footer-link-header {
     font-family: 'Avenir';
     font-weight: 600;
     font-size: 1.8rem;
 }
 li {
     font-family: 'Avenir';
     margin-top: 0;
     color:${({ theme }) => theme.colors?.white80};
     font-size: 1.4rem;
 }

 .social-links {
     list-style: none;
     display: flex;
     align-items: center;

      li {
         &:not(:first-child) {
             margin-left: 2rem;
         }
      }
     
 }

 .social-link-image {
  margin-top: 0;
     transition: ease-out 200ms transform;

     &:hover {
         transform: scale(1.2);
     }
 }



  @media (max-width: 480px) {
    //mobile
    ul {
      list-style: none;
      align-items: center;
      display: block;
      line-height: 22px;
      
    }
    .footer-link-header {
      font-family: "Avenir";
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 27px;
    }
    .social-links{
      justify-content: flex-start;
    }
    li {
      font-family: "Avenir";
      color: ${({ theme }) => theme.colors?.white80};
      font-size: 16px;
      font-weight: 400;
      opacity: 0.8;
      margin-top: 0;
    }
  }


  color: #ffffff;
  list-style: none;

  .footer-link-header {
    font-family: "Avenir";
    font-weight: 600;
    font-size: 1.8rem;
  }
  li {
    font-family: "Avenir";
    margin-top: 2.5rem;
    color: ${({ theme }) => theme.colors?.white80};
    font-size: 1.4rem;
  }

  .social-links {
    list-style: none;
    display: flex;
    align-items: center;

    li {
      &:not(:first-child) {
        margin-left: 2rem;
      }
    }
  }

  .social-link-image {
    transition: ease-out 200ms transform;

    &:hover {
      transform: scale(1.2);
    }
  }
  .hide {
    visibility: hidden;
  }
`;
